import React, { Component } from 'react';
import email from '../assets/Images/free_email_list.png';

class EmailConfirmation extends Component {
  render() {
    return (
      <div className = "main-content">
          <div className ="ccpa-wrapper">
            <div className="ccpa-form email-confirmation">
              <img src={email} alt="Email" className="email-image"/>
              <h1 className="text-bold"> One More Step! </h1>
              <h1 className="text-bold">Your identity needs to be confirmed.</h1>
              <p>Please check your email for confirmation, click confirm and we will start your request.</p>
            </div>
          </div>
      </div>
    );
  }
}

export default EmailConfirmation;
